import React from 'react'
import Avatar from '@components/Avatar'


const TooltipContent = ({ employeeData }) => {
  return (
    <div className="employee-intials-details-container employee-mp-details-container "
      style={{zIndex: 9999}}
    >
      <Avatar
        alt={employeeData.fullName}
        className="employee-initials-img"
        src={employeeData.picture}
      />
      <div>
        <div>
          <strong>{employeeData.fullName}</strong>
        </div>
        {/* <div>
          {employeeData.position}, {this.employeeData.atheneumOffice}
        </div> */}
      </div>
    </div>
  )
}

export default TooltipContent
